// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body{
    background-color: rgba(255, 255, 255, 0.575);
}
.login_box{
background-color: white;

border-radius: 10px;
box-shadow: 0px 0px 10px  rgba(0, 0, 0, 0.25);
}

.logo-container img{
    background-color: rgba(19, 76, 48, 1);
    border: 3px solid rgba(43, 167, 105, 1);
}

.green{
    color:rgba(43, 167, 105, 1);
}

.complete-info{
    color: rgba(122, 122, 122, 1);
    font-size: 14px;
}

.input-field{
    padding: 7px 20px;
    font-size: 13px;
    border-radius:5px;
    border: 1px solid rgba(122, 122, 122, 1);
    width: 100%;
    margin: 5px 0;
}

.input-field:focus{
 border: 1px solid rgba(122, 122, 122, 1) !important;
 outline: none !important;
}

.forget-pass{
    float: left;
    font-size: 13px;
}

.input-submit{
    width: 100%;
    border: none;
    background-color: rgba(43, 167, 105, 1);
    color:white;
    border-radius: 6px;
    padding: 7px;
    margin:12px 0;
    font-size: 14px;
}`, "",{"version":3,"sources":["webpack://./src/styles/login.css"],"names":[],"mappings":"AAAA;IACI,4CAA4C;AAChD;AACA;AACA,uBAAuB;;AAEvB,mBAAmB;AACnB,6CAA6C;AAC7C;;AAEA;IACI,qCAAqC;IACrC,uCAAuC;AAC3C;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,6BAA6B;IAC7B,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,iBAAiB;IACjB,wCAAwC;IACxC,WAAW;IACX,aAAa;AACjB;;AAEA;CACC,mDAAmD;CACnD,wBAAwB;AACzB;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,uCAAuC;IACvC,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,eAAe;AACnB","sourcesContent":["body{\n    background-color: rgba(255, 255, 255, 0.575);\n}\n.login_box{\nbackground-color: white;\n\nborder-radius: 10px;\nbox-shadow: 0px 0px 10px  rgba(0, 0, 0, 0.25);\n}\n\n.logo-container img{\n    background-color: rgba(19, 76, 48, 1);\n    border: 3px solid rgba(43, 167, 105, 1);\n}\n\n.green{\n    color:rgba(43, 167, 105, 1);\n}\n\n.complete-info{\n    color: rgba(122, 122, 122, 1);\n    font-size: 14px;\n}\n\n.input-field{\n    padding: 7px 20px;\n    font-size: 13px;\n    border-radius:5px;\n    border: 1px solid rgba(122, 122, 122, 1);\n    width: 100%;\n    margin: 5px 0;\n}\n\n.input-field:focus{\n border: 1px solid rgba(122, 122, 122, 1) !important;\n outline: none !important;\n}\n\n.forget-pass{\n    float: left;\n    font-size: 13px;\n}\n\n.input-submit{\n    width: 100%;\n    border: none;\n    background-color: rgba(43, 167, 105, 1);\n    color:white;\n    border-radius: 6px;\n    padding: 7px;\n    margin:12px 0;\n    font-size: 14px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
